
import { Component, Watch } from 'vue-property-decorator';

import Booking from '@/views/Booking.vue';

import { MetaInfo } from 'vue-meta';

import { ActivitiesApi } from '@/api/ActivitiesApi';

import { allActivInMotByUuidParams } from '@/interfaces/Activities';

import { mapState } from 'vuex';

import { sortBy } from 'lodash';

@Component({
   computed: {
      ...mapState({
         activities_colors: (s: any) => s.activities.colors,
      }),
   },
   metaInfo(): MetaInfo {
      return {
         title: 'Shared activity report',
      };
   },
   filters: {
      formatDate: (act_day: any) => (act_day != null ? new Date(act_day * 8.64e7).toISOString() : ''),
      capitalizeFirstLetter: (value: string | number) => (typeof value == 'string' ? value.charAt(0).toUpperCase() + value.slice(1) : ''),
   },
})
export default class ActivityReport extends Booking {
   stripos!: any;

   addColorTooltips!: any;

   //dateRange: Date[] = [];

   activities_colors!: any[];

   customFormatter!: any;

   operationName: any = '';

   modalData: any = {
      title: '',
      name: '',
      comment: '',
   };

   modalError: any = {
      name: false,
      comment: false,
   };

   supplier_fields: any[] = [
      {
         key: 'act_status',
         label: 'status',
         thAttr: {
            style: 'width: 120px;',
         },
      },
      {
         key: 'act_name',
         sortable: true,
         label: 'activity',
         thAttr: {
            style: 'width: 500px;',
         },
         tdAttr: {
            style: 'text-align: center;',
         },
      },
      {
         key: 'act_day',
         sortable: true,
         label: 'Activity date',
         tdAttr: {
            style: 'text-align: center;',
         },
         thAttr: {
            style: 'width: 100px;',
         },
      },
      {
         key: 'act_pax',
         sortable: true,
         label: 'pax',
         tdAttr: {
            style: 'text-align: center;',
         },
         thAttr: {
            style: 'width: 50px;',
         },
      },
      {
         key: 'moto_lead_guest',
         sortable: true,
         label: 'Main guest',
         tdAttr: {
            style: 'text-align: center;',
         },
         thAttr: {
            style: 'width: 150px;',
         },
      },
      {
         key: 'moto_our_reference',
         sortable: true,
         label: 'GROUP REFERENCE',
         tdAttr: {
            style: 'text-align: center;',
         },
         thAttr: {
            style: 'width: 50px;',
         },
      },
      {
         key: 'act_time',
         sortable: true,
         label: 'Activity Start Time',
         tdAttr: {
            style: 'text-align: center;',
         },
         thAttr: {
            style: 'width: 90px;',
         },
      },
      {
         key: 'act_cost',
         sortable: true,
         label: 'act cost €',
         tdAttr: {
            style: 'text-align: center;',
         },
         thAttr: {
            style: 'width: 100px;',
         },
      },
      {
         key: 'act_notes',
         sortable: false,
         label: 'supplier notes',
         tdAttr: {
            style: 'text-align: center;',
         },
      },
   ];

   transfer_fields: any[] = [
      {
         key: 'act_status',
         label: 'status',
         thAttr: {
            style: 'width: 52px;',
         },
      },
      {
         key: 'act_day',
         sortable: true,
         label: 'Activity day',
         tdAttr: {
            style: 'text-align: center;',
         },
         thAttr: {
            style: 'font-size:10px; width: 100px;',
         },
      },
      {
         key: 'act_time',
         sortable: true,
         label: 'pick up time',
         tdAttr: {
            style: 'text-align: center;',
         },
         thAttr: {
            style: 'font-size:10px; width: 55px;',
         },
      },
      {
         key: 'act_pax',
         sortable: true,
         label: 'pax',
         tdAttr: {
            style: 'text-align: center;',
         },
         thAttr: {
            style: 'font-size:10px; width: 50px;',
         },
      },
      {
         key: 'moto_our_reference',
         sortable: true,
         label: 'GROUP REFERENCE',
         tdAttr: {
            style: 'text-align: center;',
         },
         thAttr: {
            style: 'font-size:10px; width: 50px;',
         },
      },
      {
         key: 'moto_lead_guest',
         sortable: true,
         label: 'main guest',
         thAttr: {
            style: 'width: 100px;font-size:10px;',
         },
         tdAttr: {
            style: 'text-align: center;',
         },
      },
      {
         key: 'moto_group_phone',
         sortable: true,
         label: 'main guest phone',
         tdAttr: {
            style: 'text-align: center;',
         },
         thAttr: {
            style: 'width: 100px;font-size:10px;',
         },
      },
      {
         key: 'act_name',
         sortable: true,
         label: 'activity',
         thAttr: {
            style: 'font-size:10px; width: 180px;',
         },
         tdAttr: {
            style: 'text-align: center;',
         },
      },
      {
         key: 'act_waiting_time',
         sortable: true,
         label: 'waiting time',
         thAttr: {
            style: 'font-size:10px; width: 55px;',
         },
         tdAttr: {
            style: 'text-align: center;',
         },
      },
      {
         key: 'act_transfer_zone',
         sortable: true,
         label: 'zone',
         thAttr: {
            style: 'font-size:10px; width: 55px;',
         },
         tdAttr: {
            style: 'text-align: center;',
         },
      },
      {
         key: 'act_address_phone',
         sortable: true,
         label: 'activity address, phone',
         thAttr: {
            style: 'width: 150px;font-size:10px;',
         },
         tdAttr: {
            style: 'text-align: center;',
         },
      },
      /*
      {
         key: 'act_direction',
         sortable: true,
         label: 'activity direction',
         thAttr: {
            style: 'width: 70px;font-size:10px;',
         },
         tdAttr: {
            style: 'text-align: center;',
         },
      },
      */
      {
         key: 'act_waze',
         sortable: true,
         label: 'Activity Waze link',
         thAttr: {
            style: 'width:80px;font-size:10px;',
         },
         tdAttr: {
            style: 'width:80px;text-align: center;',
         },
      },
      {
         key: 'act_transfer_driver_notes',
         sortable: true,
         label: 'TRANSFER NOTES (DRIVER)',
         thAttr: {
            style: 'width: 250px;font-size:10px;',
         },
         tdAttr: {
            style: 'text-align: center;',
         },
      },
      {
         key: 'act_guide',
         sortable: true,
         label: 'GUIDE',
         thAttr: {
            style: 'width: 120px;font-size:10px;',
         },
         tdAttr: {
            style: 'width: 120px;text-align: center;',
         },
      },
      {
         key: 'arrival_info',
         sortable: true,
         label: 'Arrival Flight Nr, Date, time',
         thAttr: {
            style: 'width: 120px;font-size:10px;',
         },
         tdAttr: {
            style: 'width: 120px;text-align: center;',
         },
      },
      {
         key: 'departure_info',
         sortable: true,
         label: 'Departure Flight Nr, Date, time',
         thAttr: {
            style: 'width: 120px;font-size:10px;',
         },
         tdAttr: {
            style: 'width: 120px;text-align: center;',
         },
      },
      {
         key: 'moto_group_accommodation_address',
         sortable: true,
         label: 'Group accommodation address',
         thAttr: {
            style: 'width: 150px;font-size:10px;',
         },
         tdAttr: {
            style: 'text-align: center;',
         },
      },
      {
         key: 'act_start_time',
         sortable: true,
         label: 'Activity Start Time',
         thAttr: {
            style: 'font-size:10px; width: 55px;',
         },
         tdAttr: {
            style: 'text-align: center;',
         },
      },
      {
         key: 'act_transfer_group_notes',
         sortable: true,
         label: 'TRANSFER NOTES (GROUP)',
         thAttr: {
            style: 'width: 150px;font-size:10px;',
         },
         tdAttr: {
            style: 'text-align: center;',
         },
      },
   ];

   guide_fields: any[] = [
      {
         key: 'act_status',
         label: 'status',
         thAttr: {
            style: 'font-size:10px; width: 145px;',
         },
      },
      {
         key: 'act_day',
         sortable: true,
         label: 'Activity day',
         tdAttr: {
            style: 'text-align: center;',
         },
         thAttr: {
            style: 'font-size:10px; width: 100px;',
         },
      },
      {
         key: 'act_time',
         sortable: true,
         label: 'pick up time',
         tdAttr: {
            style: 'text-align: center;',
         },
         thAttr: {
            style: 'font-size:10px; width: 55px;',
         },
      },
      {
         key: 'act_start_time',
         sortable: true,
         label: 'Activity Start Time',
         tdAttr: {
            style: 'text-align: center;',
         },
         thAttr: {
            style: 'font-size:10px; width: 55px;',
         },
      },
      {
         key: 'act_pax',
         sortable: true,
         label: 'pax',
         tdAttr: {
            style: 'text-align: center;',
         },
         thAttr: {
            style: 'font-size:10px; width: 50px;',
         },
      },
      {
         key: 'moto_lead_guest',
         sortable: true,
         label: 'main guest',
         thAttr: {
            style: 'font-size:10px;',
         },
         tdAttr: {
            style: 'text-align: center;',
         },
      },
      {
         key: 'moto_group_phone',
         sortable: true,
         label: 'main guest phone',
         tdAttr: {
            style: 'text-align: center;',
         },
         thAttr: {
            style: 'font-size:10px;',
         },
      },
      {
         key: 'act_name',
         sortable: true,
         label: 'activity',
         thAttr: {
            style: 'font-size:10px; width: 180px;',
         },
         tdAttr: {
            style: 'text-align: center;',
         },
      },
      {
         key: 'act_address_phone',
         sortable: true,
         label: 'activity address, phone',
         thAttr: {
            style: 'font-size:10px;',
         },
         tdAttr: {
            style: 'text-align: center;',
         },
      },
      {
         key: 'act_direction',
         sortable: true,
         label: 'activity direction',
         thAttr: {
            style: 'font-size:10px;',
         },
         tdAttr: {
            style: 'text-align: center;',
         },
      },
      {
         key: 'act_waze',
         sortable: true,
         label: 'Activity Waze link',
         thAttr: {
            style: 'width:80px;font-size:10px;',
         },
         tdAttr: {
            style: 'width:80px;text-align: center;',
         },
      },
      {
         key: 'act_transfer',
         sortable: true,
         label: 'TRANSFER',
         thAttr: {
            style: 'font-size:10px;',
         },
         tdAttr: {
            style: 'text-align: center;',
         },
      },
      {
         key: 'act_transfer_driver_notes',
         sortable: true,
         label: 'TRANSFER NOTES (DRIVER)',
         thAttr: {
            style: 'font-size:10px;',
         },
         tdAttr: {
            style: 'text-align: center;',
         },
      },
      {
         key: 'act_guide',
         sortable: true,
         label: 'GUIDE',
         thAttr: {
            style: 'font-size:10px;',
         },
         tdAttr: {
            style: 'text-align: center;',
         },
      },
      {
         key: 'arrival_info',
         sortable: true,
         label: 'Arrival Flight Nr, Date, time',
         thAttr: {
            style: 'font-size:10px;',
         },
         tdAttr: {
            style: 'width: 100px;text-align: center;',
         },
      },
      {
         key: 'departure_info',
         sortable: true,
         label: 'Departure Flight Nr, Date, time',
         thAttr: {
            style: 'font-size:10px;',
         },
         tdAttr: {
            style: 'text-align: center;',
         },
      },
      {
         key: 'moto_group_accommodation_address',
         sortable: true,
         label: 'Group accommodation address',
         thAttr: {
            style: 'font-size:10px;',
         },
         tdAttr: {
            style: 'text-align: center;',
         },
      },
      {
         key: 'act_guide_group_notes',
         sortable: true,
         label: 'GUIDES NOTES',
         thAttr: {
            style: 'font-size:10px;',
         },
         tdAttr: {
            style: 'text-align: center;',
         },
      },
      {
         key: 'act_transfer_group_notes',
         sortable: true,
         label: 'TRANSFER NOTES (GROUP)',
         thAttr: {
            style: 'font-size:10px;',
         },
         tdAttr: {
            style: 'text-align: center;',
         },
      },
   ];

   items: any[] = [];

   filtered_suppliers: any[] = [];

   filtered_transfers: any[] = [];

   filtered_guides: any[] = [];

   type: any = [];

   filter: any = {
      act_status: '#ffffff',
      act_day: '',
      act_name: '',
      act_pax: '',
      act_time: '',
      act_cost: '',
      act_notes: '',
   };

   filter_transfer: any = {
      act_status: '#ffffff',
      act_day: '',
      act_time: '',
      act_pax: '',
      moto_lead_guest: '',
      moto_group_phone: '',
      act_name: '',
      act_address_phone: '',
      act_direction: '',
      act_waze: '',
      act_transfer_driver_notes: '',
      act_guide: '',
      arrival_info: '',
      departure_info: '',
      moto_group_accommodation_address: '',
      act_transfer_group_notes: '',
   };

   filter_guide: any = {
      act_status: '#ffffff',
      act_day: '',
      act_time: '',
      act_pax: '',
      act_start_time: '',
      moto_lead_guest: '',
      moto_group_phone: '',
      act_name: '',
      act_address_phone: '',
      act_direction: '',
      act_waze: '',
      act_transfer: '',
      act_transfer_driver_notes: '',
      act_guide: '',
      arrival_info: '',
      departure_info: '',
      moto_group_accommodation_address: '',
      act_transfer_group_notes: '',
      act_guide_group_notes: '',
   };

   created(): void {
      this.type = this.$route.query.type as string;
      this.operationName = this.$route.query.operationName;
   }

   mounted(): void {
      this.getData();
   }

   getData() {
      const params: allActivInMotByUuidParams = {
         type: this.$route.query.type,
         uuid: this.$route.params.id,
         //fromDate: this.$moment(this.dateRange[0]).format('YYYY-MM-DD'),
         //toDate: this.$moment(this.dateRange[1]).format('YYYY-MM-DD'),
         fromDate: this.$moment()
            .subtract(2, 'month')
            .format('YYYY-MM-DD'),
         toDate: this.$moment(this.$moment().format('YYYY') + '-12-31')
            .add(1, 'year')
            .format('YYYY-MM-DD'),
      };

      if (!params.fromDate || !params.toDate) return;

      this.$store.commit('showLoading');
      this.$store.commit('setItems', { name: 'ready', value: false });
      ActivitiesApi.allActivInMotByUuid(params)
         .then(data => {
            this.items = sortBy(
               data.Activities.filter((c: any) => c.act_status !== 'FF2D00'),
               ['act_day', 'act_time']
            );
            this.addColorTooltips(['.orders-list'], this.activities_colors);
         })
         .finally(() => {
            this.filterData();
            this.$store.commit('setItems', { name: 'ready', value: true });
            this.$store.commit('hideLoading');
         });
   }

   filterData() {
      let filter: any;
      let filter_transfer: any;
      let filter_guide: any;
      const titleEl: any = document.querySelector('head title');
      switch (this.type) {
         case 'activity':
            titleEl.textContent = 'Shared activity report for activity supplier - ' + this.operationName;
            filter = {
               act_status: '#ffffff',
               act_day: '',
               act_name: '',
               act_pax: '',
               act_time: '',
               act_cost: '',
               act_notes: '',
               ...this.filter,
            };
            this.filtered_suppliers = this.items.filter(a => {
               return (
                  (['#ffffff', 'ffffff'].includes(filter['act_status'].toLowerCase()) || this.stripos(a.act_status, filter['act_status'])) &&
                  (filter['act_name'] === '' || this.stripos(a.act_name, filter['act_name'])) &&
                  (filter['act_pax'] === '' || this.stripos(a.act_pax, filter['act_pax'])) &&
                  (filter['act_time'] === '' || this.stripos(a.act_time, filter['act_time'])) &&
                  (filter['act_cost'] === '' || this.stripos(a.act_cost, filter['act_cost'])) &&
                  (filter['moto_lead_guest'] === '' || this.stripos(a.moto_lead_guest, filter['moto_lead_guest'])) &&
                  (filter['act_notes'] === '' || this.stripos(a.act_notes, filter['act_notes'])) &&
                  ([null, ''].includes(filter['act_day']) ||
                     this.$moment((this.$options.filters as any).formatDate(a.act_day)).format('YYYYDDMM') ===
                        this.$moment(filter['act_day']).format('YYYYDDMM'))
               );
            });
            break;
         case 'transfer':
            titleEl.textContent = 'Shared activity report for activity transfer - ' + this.operationName;
            filter_transfer = {
               act_status: '#ffffff',
               act_day: '',
               act_time: '',
               act_pax: '',
               moto_lead_guest: '',
               moto_group_phone: '',
               act_name: '',
               act_address_phone: '',
               act_direction: '',
               act_waze: '',
               act_transfer_driver_notes: '',
               act_guide: '',
               arrival_info: '',
               departure_info: '',
               moto_group_accommodation_address: '',
               act_transfer_group_notes: '',
               ...this.filter_transfer,
            };

            this.filtered_transfers = this.items.filter(a => {
               return (
                  (['#ffffff', 'ffffff'].includes(filter_transfer['act_status'].toLowerCase()) ||
                     this.stripos(a.act_status, filter_transfer['act_status'])) &&
                  (filter_transfer['act_time'] === '' || this.stripos(a.act_time, filter_transfer['act_time'])) &&
                  (filter_transfer['act_pax'] === '' || this.stripos(a.act_pax, filter_transfer['act_pax'])) &&
                  (filter_transfer['moto_lead_guest'] === '' || this.stripos(a.moto_lead_guest, filter_transfer['moto_lead_guest'])) &&
                  (filter_transfer['moto_group_phone'] === '' || this.stripos(a.moto_group_phone, filter_transfer['moto_group_phone'])) &&
                  (filter_transfer['act_name'] === '' || this.stripos(a.act_name, filter_transfer['act_name'])) &&
                  (filter_transfer['act_address_phone'] === '' || this.stripos(a.act_address_phone, filter_transfer['act_address_phone'])) &&
                  (filter_transfer['act_direction'] === '' || this.stripos(a.act_direction, filter_transfer['act_direction'])) &&
                  (filter_transfer['act_waze'] === '' || this.stripos(a.act_waze, filter_transfer['act_waze'])) &&
                  (filter_transfer['act_transfer_driver_notes'] === '' ||
                     this.stripos(a.act_transfer_driver_notes, filter_transfer['act_transfer_driver_notes'])) &&
                  (filter_transfer['act_guide'] === '' || this.stripos(a.act_guide, filter_transfer['act_guide'])) &&
                  (filter_transfer['arrival_info'] === '' || this.stripos(a.arrival_info, filter_transfer['arrival_info'])) &&
                  (filter_transfer['departure_info'] === '' || this.stripos(a.departure_info, filter_transfer['departure_info'])) &&
                  (filter_transfer['moto_group_accommodation_address'] === '' ||
                     this.stripos(a.moto_group_accommodation_address, filter_transfer['moto_group_accommodation_address'])) &&
                  (filter_transfer['act_transfer_group_notes'] === '' ||
                     this.stripos(a.act_transfer_group_notes, filter_transfer['act_transfer_group_notes'])) &&
                  ([null, ''].includes(filter_transfer['act_day']) ||
                     this.$moment(a.act_day).format('YYYYDDMM') === this.$moment(filter_transfer['act_day']).format('YYYYDDMM'))
               );
            });
            break;
         case 'guide':
            titleEl.textContent = 'Shared activity report for activity guide  - ' + this.operationName;
            filter_guide = {
               act_status: '#ffffff',
               act_day: '',
               act_time: '',
               act_pax: '',
               act_start_time: '',
               moto_lead_guest: '',
               moto_group_phone: '',
               act_name: '',
               act_address_phone: '',
               act_direction: '',
               act_waze: '',
               act_transfer: '',
               act_transfer_driver_notes: '',
               act_guide: '',
               arrival_info: '',
               departure_info: '',
               moto_group_accommodation_address: '',
               act_transfer_group_notes: '',
               act_guide_group_notes: '',
               ...this.filter_guide,
            };

            this.filtered_guides = this.items.filter(a => {
               return (
                  (['#ffffff', 'ffffff'].includes(filter_guide['act_status'].toLowerCase()) ||
                     this.stripos(a.act_status, filter_guide['act_status'])) &&
                  (filter_guide['act_time'] === '' || this.stripos(a.act_time, filter_guide['act_time'])) &&
                  (filter_guide['act_pax'] === '' || this.stripos(a.act_pax, filter_guide['act_pax'])) &&
                  (filter_guide['act_start_time'] === '' || this.stripos(a.act_start_time, filter_guide['act_start_time'])) &&
                  (filter_guide['moto_lead_guest'] === '' || this.stripos(a.moto_lead_guest, filter_guide['moto_lead_guest'])) &&
                  (filter_guide['moto_group_phone'] === '' || this.stripos(a.moto_group_phone, filter_guide['moto_group_phone'])) &&
                  (filter_guide['act_name'] === '' || this.stripos(a.act_name, filter_guide['act_name'])) &&
                  (filter_guide['act_address_phone'] === '' || this.stripos(a.act_address_phone, filter_guide['act_address_phone'])) &&
                  (filter_guide['act_direction'] === '' || this.stripos(a.act_direction, filter_guide['act_direction'])) &&
                  (filter_guide['act_guide_group_notes'] === '' || this.stripos(a.act_guide_group_notes, filter_guide['act_guide_group_notes'])) &&
                  (filter_guide['act_waze'] === '' || this.stripos(a.act_waze, filter_guide['act_waze'])) &&
                  (filter_guide['act_transfer'] === '' || this.stripos(a.act_transfer, filter_guide['act_transfer'])) &&
                  (filter_guide['act_transfer_driver_notes'] === '' ||
                     this.stripos(a.act_transfer_driver_notes, filter_guide['act_transfer_driver_notes'])) &&
                  (filter_guide['act_guide'] === '' || this.stripos(a.act_guide, filter_guide['act_guide'])) &&
                  (filter_guide['arrival_info'] === '' || this.stripos(a.arrival_info, filter_guide['arrival_info'])) &&
                  (filter_guide['departure_info'] === '' || this.stripos(a.departure_info, filter_guide['departure_info'])) &&
                  (filter_guide['moto_group_accommodation_address'] === '' ||
                     this.stripos(a.moto_group_accommodation_address, filter_guide['moto_group_accommodation_address'])) &&
                  (filter_guide['act_transfer_group_notes'] === '' ||
                     this.stripos(a.act_transfer_group_notes, filter_guide['act_transfer_group_notes'])) &&
                  ([null, ''].includes(filter_guide['act_day']) ||
                     this.$moment(a.act_day).format('YYYYDDMM') === this.$moment(filter_guide['act_day']).format('YYYYDDMM'))
               );
            });
            break;
      }
   }

   activityConfirmation(item: any, type: string) {
      if ([1993, 2113, 1996].includes(parseInt(item.act_status_id))) {
         const title = type.toUpperCase() + ' CONFIRMATION';
         this.modalData = { ...item, title: title, name: '', comment: '' };
         this.modalError = {
            ...this.modalError,
            name: false,
            comment: false,
         };
         this.$bvModal.show('activity-confirmation-modal');
      }
   }

   submitActivity(type: string, typeActivity: string) {
      if (this.validated(type)) {
         this.$store.commit('showLoading');
         this.modalData.type = typeActivity;
         switch (type) {
            case 'accept':
               ActivitiesApi.acceptActivity(this.modalData).then(response => {
                  if (response.data == 1) {
                     this.$bvModal.hide('activity-confirmation-modal');
                     this.$bvToast.toast('Success', {
                        title: '',
                        variant: 'success',
                        solid: true,
                     });
                     setTimeout(() => {
                        window.location.reload();
                     }, 3000);
                  } else {
                     this.$bvToast.toast(response.data, {
                        title: 'Error',
                        variant: 'danger',
                        solid: true,
                     });
                  }
               });
               break;
            case 'decline':
               ActivitiesApi.rejectActivity(this.modalData).then(response => {
                  if (response.data == 1) {
                     this.$bvModal.hide('activity-confirmation-modal');
                     this.$bvToast.toast('Success', {
                        title: '',
                        variant: 'success',
                        solid: true,
                     });
                     setTimeout(() => {
                        window.location.reload();
                     }, 3000);
                  } else {
                     this.$bvToast.toast(response.data, {
                        title: 'Error',
                        variant: 'danger',
                        solid: true,
                     });
                  }
               });
               break;
         }
      }
   }

   validated(type: string) {
      if (type == 'accept' && !this.modalData.name) {
         this.modalError.name = true;
         return;
      }
      if (type == 'decline' && (!this.modalData.name || !this.modalData.comment)) {
         this.modalError.name = true;
         this.modalError.comment = true;
         return;
      }
      return true;
   }

   createReport(id: number, rep_code: string, type: string, act_id: number | null) {
      this.$store.commit('showLoading');
      ActivitiesApi.createReport({ id, rep_code, type, act_id }).finally(() => {
         this.$store.commit('hideLoading');
      });
   }

   @Watch('filter', { immediate: true, deep: true })
   changeFilter(filter: any, old: any) {
      const query = { ...this.$route.query, ...filter };

      if (query['act_day'] !== '') {
         query['act_day'] = this.$moment(query['act_day']).format();
      }

      this.$router.push({ query }).catch(() => {});
      this.filterData();
   }

   @Watch('filter_transfer', { immediate: true, deep: true })
   changeFilterTransfer(filter_transfer: any, old: any) {
      const query = { ...this.$route.query, ...filter_transfer };

      if (query['act_day'] !== '') {
         query['act_day'] = this.$moment(query['act_day']).format();
      }

      this.$router.push({ query }).catch(() => {});
      this.filterData();
   }

   @Watch('filter_guide', { immediate: true, deep: true })
   changeFilterGuide(filter_guide: any, old: any) {
      const query = { ...this.$route.query, ...filter_guide };

      if (query['act_day'] !== '') {
         query['act_day'] = this.$moment(query['act_day']).format();
      }

      this.$router.push({ query }).catch(() => {});
      this.filterData();
   }
}
